import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import { Accessibility } from './Accessibility';
import { IProfileInfo } from '../../models/IProfileInfo';

interface IProps {
    ProfileInfo: IProfileInfo,
    SearchToggle: () => void
}

interface IState {
    NavOptionsOpen: string,
    NavExpanded: boolean
}

export class NavMenu extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            NavOptionsOpen: "",
            NavExpanded: false
        }

        this.SearchToggle = this.SearchToggle.bind(this);
        this.ToggleOptions = this.ToggleOptions.bind(this);
        this.Sso = this.Sso.bind(this);
        this.NavExpandedToggle = this.NavExpandedToggle.bind(this);
        this.OnSelect = this.OnSelect.bind(this);
        this.NavbarOnToggle = this.NavbarOnToggle.bind(this);
    }

    public render() {
        return (
            <Navbar
                collapseOnSelect={true}
                inverse={true}
                staticTop={true}
                fluid={true}
                expanded={this.state.NavExpanded}
                onToggle={this.NavbarOnToggle}>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link className="home-button" to={'/'}>
                            Znajdź Fizjoterapeutę
                            <Link to="/blog">
                                <span className="home-button-blog">Blog</span>
                            </Link>
                            <Link to="/">
                                <span className="home-button-subpage">Dla pacjenta</span>
                            </Link>
                            <Link to="/dlafizjoterapeuty">
                                <span className="home-button-subpage home-button-physio">Dla fizjoterapeuty</span>
                            </Link>
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.NavExpandedToggle} />
                    <Navbar.Brand>
                        <div className="search-button" onClick={this.SearchToggle} />
                    </Navbar.Brand>
                </Navbar.Header>
                {this.RenderMenuContent()}
            </Navbar>
        );
    }

    private NavExpandedToggle(evt) {
        this.setState({
            NavExpanded: !this.state.NavExpanded
        });
    }

    private OnSelect(evt) {
        this.setState({
            NavExpanded: false
        });
    }

    private RenderMenuContent() {
        if (this.props.ProfileInfo.Role === "Physiotherapist") {
            return this.RenderPhysiotherapistMenu();
        }
        if (this.props.ProfileInfo.Role === "Customer") {
            return this.RenderCustomerMenu();
        }
        if (this.props.ProfileInfo.Role === "Admin") {
            return this.RenderAdminMenu();
        }
        return this.RenderAnonymousMenu();
    }

    private RenderPhysiotherapistMenu() {
        return (
            <Navbar.Collapse className="menu-panel">
                <Nav className="menu-side nav navbar-nav">
                    <React.Fragment>
                        <Link className="logo" to={'/'}>&nbsp;</Link>
                        <LinkContainer
                            to={'/physiotherapist/edit'} onSelect={this.OnSelect}
                            className=""
                            activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-profile">Profil</NavItem>
                        </LinkContainer>
                        <LinkContainer
                            to={'/scheduler'} onSelect={this.OnSelect}
                            className=""
                            activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-calendar">Kalendarz</NavItem>
                        </LinkContainer>
                        <LinkContainer
                            to={'/visit/list'} onSelect={this.OnSelect}
                            className=""
                            activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-visits">Wizyty</NavItem>
                        </LinkContainer>
                        <li className="menu-side-btn menu-side-btn-pf">
                            <a href="https://portal.kif.info.pl/" target="_blank">Portal Fizjoterapeuty</a>
                        </li>
                        <LinkContainer
                            to={'/logout'} onSelect={this.OnSelect}
                            className=""
                            activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-logout mobile-only">Wyloguj się</NavItem>
                        </LinkContainer>
                    </React.Fragment>
                </Nav>
                <Nav className={`menu-dropdown menu-dropdown-panel ${this.props.ProfileInfo.ProfileImgUrl ? "menu-with-image" : ""}`}
                    pullRight={true}>
                    <React.Fragment>
                        <span className="username">
                            {
                                this.props.ProfileInfo.ProfileImgUrl &&
                                <span className="avatar"
                                    style={
                                        { backgroundImage: `url('${this.props.ProfileInfo.ProfileImgUrl}')` }
                                    }
                                />
                            }
                            <span className="username-text">
                                {
                                    this.props.ProfileInfo.FirstName !== null && this.props.ProfileInfo.FirstName !== undefined ?
                                        this.props.ProfileInfo.FirstName :
                                        this.props.ProfileInfo.Username
                                }
                            </span>
                        </span>
                        <div className="menu-dropdown-list">
                            <LinkContainer onSelect={this.OnSelect} to={'/logout'} activeClassName="">
                                <NavItem className="menu-dropdown-btn logout">Wyloguj się</NavItem>
                            </LinkContainer>
                        </div>
                    </React.Fragment>
                </Nav>
            </Navbar.Collapse>
        );
    }

    private RenderCustomerMenu() {
        return (
            <Navbar.Collapse className="menu-panel">
                <Nav className="menu-side nav navbar-nav">
                    <React.Fragment>
                        <Link onSelect={this.OnSelect} className="logo" to={'/'}>&nbsp;</Link>
                        <LinkContainer onSelect={this.OnSelect} to={'/myvisits'} activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-visits">Wizyty</NavItem>
                        </LinkContainer>
                        <LinkContainer onSelect={this.OnSelect} to={'/favorite/list'} activeClassName="menu-side-btn-active">
                            <NavItem className="menu-side-btn menu-side-btn-favorite">Polubieni Fizjoterapeuci</NavItem>
                        </LinkContainer>
                        <LinkContainer onSelect={this.OnSelect} to={'/customer/account/edit'} activeClassName="">
                            <NavItem className="menu-side-btn menu-side-btn-settings mobile-only">Ustawienia konta</NavItem>
                        </LinkContainer>
                        <LinkContainer onSelect={this.OnSelect} to={'/logout'} activeClassName="">
                            <NavItem className="menu-side-btn menu-side-btn-logout mobile-only">Wyloguj się</NavItem>
                        </LinkContainer>
                    </React.Fragment>
                </Nav>
                <Nav className="menu-dropdown menu-dropdown-panel" pullRight={true}>
                    <React.Fragment>
                        <Accessibility />
                        <span className="username">
                            {
                                this.props.ProfileInfo.FirstName !== null && this.props.ProfileInfo.FirstName !== undefined ?
                                    this.props.ProfileInfo.FirstName :
                                    this.props.ProfileInfo.Username
                            }
                        </span>
                        <div className="menu-dropdown-list">
                            <LinkContainer onSelect={this.OnSelect} to={'/customer/account/edit'} activeClassName="">
                                <NavItem className="menu-dropdown-btn settings">Ustawienia konta</NavItem>
                            </LinkContainer>
                            <LinkContainer onSelect={this.OnSelect} to={'/logout'} activeClassName="">
                                <NavItem className="menu-dropdown-btn logout">Wyloguj się</NavItem>
                            </LinkContainer>
                        </div>
                    </React.Fragment>
                </Nav>
            </Navbar.Collapse>
        );
    }

    private RenderAdminMenu() {
        return (
            <Navbar.Collapse className="menu-panel admin-menu">
                <Nav className="menu-side nav navbar-nav">
                    <Link onSelect={this.OnSelect} className="logo" to={'/'}>&nbsp;</Link>
                    <LinkContainer onSelect={this.OnSelect} to={'/accept/trainingcourses'} activeClassName="">
                        <NavItem className="menu-side-btn menu-side-btn-visits">Akceptacja szkoleń</NavItem>
                    </LinkContainer>
                    <LinkContainer onSelect={this.OnSelect} to={'/statistics'} activeClassName="">
                        <NavItem className="menu-side-btn menu-side-btn-visits">Statystyki</NavItem>
                    </LinkContainer>
                    <LinkContainer onSelect={this.OnSelect} to={'/managesitemap'} activeClassName="">
                        <NavItem className="menu-side-btn menu-side-btn-visits">Mapa strony</NavItem>
                    </LinkContainer>
                    <LinkContainer onSelect={this.OnSelect} to={'/logout'} activeClassName="">
                        <NavItem className="menu-side-btn menu-side-btn-visits">Wyloguj się</NavItem>
                    </LinkContainer>
                </Nav>
            </Navbar.Collapse>
        );
    }

    private RenderAnonymousMenu() {
        return (
            <Navbar.Collapse>
                <Nav pullRight={true}>
                    <React.Fragment>
                        <Accessibility />

                        <div className="home-button-subpage">
                            <LinkContainer to="/" onSelect={this.OnSelect} activeClassName="">
                                <NavItem className="">Dla pacjenta</NavItem>
                            </LinkContainer>
                        </div>

                        <div className="home-button-subpage home-button-physio">
                            <LinkContainer to="/dlafizjoterapeuty" onSelect={this.OnSelect} activeClassName="">
                                <NavItem className="">Dla fizjoterapeuty</NavItem>
                            </LinkContainer>
                        </div>

                        <div className="menu-dropdown menu-dropdown-main">
                            <div className="std-secondary-btn-alt login-btn"
                                id="login"
                                onClick={this.ToggleOptions}>Zaloguj się</div>
                            <Nav className={`menu-dropdown-list menu-dropdown-list-main ${this.state.NavOptionsOpen === "login" ? "mobile-open" : "mobile-closed"}`}>
                                <React.Fragment>
                                    <LinkContainer onSelect={this.OnSelect} to={'/login'} activeClassName="">
                                        <NavItem className="menu-dropdown-btn menu-dropdown-btn-main">Pacjent</NavItem>
                                    </LinkContainer>
                                    <li onSelect={this.OnSelect} role="presentation" className="menu-dropdown-btn menu-dropdown-btn-main">
                                        <a href="#" onClick={this.Sso}>Fizjoterapeuta</a>
                                    </li>
                                </React.Fragment>
                            </Nav>
                        </div>
                        <div className="menu-dropdown menu-dropdown-main">
                            <div className="menu-dropdown-list-header register-btn"
                                id="register"
                                onClick={this.ToggleOptions}>Zarejestruj się</div>
                            <Nav className={`menu-dropdown-list menu-dropdown-list-main ${this.state.NavOptionsOpen === "register" ? "mobile-open" : "mobile-closed"}`}>
                                <React.Fragment>
                                    <LinkContainer onSelect={this.OnSelect} to={'/register'} activeClassName="">
                                        <NavItem className="menu-dropdown-btn menu-dropdown-btn-main">Pacjent</NavItem>
                                    </LinkContainer>
                                    <li onSelect={this.OnSelect} role="presentation" className="menu-dropdown-btn menu-dropdown-btn-main">
                                        <a href='https://logowanie.kif.info.pl/register'>Fizjoterapeuta</a>
                                    </li>
                                </React.Fragment>
                            </Nav>
                        </div>
                        <div className="blog-button">
                            <LinkContainer onSelect={this.OnSelect} to={'/blog'} activeClassName="">
                                <NavItem className="menu-dropdown-btn menu-dropdown-btn-main">Blog</NavItem>
                            </LinkContainer>
                        </div>
                    </React.Fragment>
                </Nav>
            </Navbar.Collapse>
        );
    }

    private SearchToggle(evt) {
        this.props.SearchToggle();
    }

    private Sso(e) {
        e.preventDefault();
        (window as any).location.assign("/api/account/sso");
    }

    private ToggleOptions(evt) {
        const opt = (evt.target as HTMLElement).id;
        this.setState({
            NavOptionsOpen: opt === this.state.NavOptionsOpen ? "" : opt
        });
    }

    private NavbarOnToggle() {
        //null
    }
}


// WEBPACK FOOTER //
// ./src/components/NavMenu/NavMenu.tsx